<template>
  <template v-if="enableStatusChange">
    <SfButtonDs
      v-tooltip="currentStatus?.name"
      class="tw-max-w-[200px] sf-button--full-width-label"
      icon-before="pencil"
      data-testid="change-workflow-status-button"
      @click="openWorkflowStatusChangeForm"
    >
      <span class="tw-min-w-0 tw-truncate">
        {{ I18n.t('workflow_statuses.actions.status') }}:
        {{ currentStatus?.name }}
      </span>
    </SfButtonDs>
    <WorkflowStatusChangeForm
      :workflow-id="workflowId"
      :workflow-status-id="currentWorkflowStatusId"
      :workflow-statuses="workflowStatuses"
      :workflow-name="workflowName"
      :workflow-status-change-form-visible="workflowStatusChangeFormVisible"
      @close-workflow-status-change-form="closeWorkflowStatusChangeForm"
      @set-status-and-hide-form="setStatusAndHideForm"
    />
  </template>
  <template v-else>
    <div
      class="sf-font-s sf-font-normal workflow-status__container"
      data-testid="workflow-status-label"
    >
      <span
        v-if="currentStatus"
        class="
          sf-label sf-label-rectangular
          workflow-status__label
          sf-c-text-darker
        "
        :class="statusChangeButtonClass"
      >
        {{ currentStatus.name }}
      </span>
    </div>
  </template>
</template>

<script lang="ts">
import { SfButtonDs } from '@silverfin/ui-components'
import WorkflowStatusChangeForm from './workflow-status-change-form.vue'

const WorkflowStatus = {
  name: 'WorkflowStatus',
  components: { WorkflowStatusChangeForm, SfButtonDs },
  props: {
    enableStatusChange: {
      type: Boolean,
      default: false,
    },
    workflowId: {
      type: Number,
      required: true,
    },
    workflowStatusId: {
      type: Number,
      required: false,
      default: null,
    },
    workflowName: {
      type: String,
      required: true,
    },
    workflowStatuses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      workflowStatusChangeFormVisible: false,
      currentWorkflowStatusId: this.workflowStatusId,
      changeStatusMessage: () =>
        this.currentWorkflowStatusId
          ? window.I18n.t('workflow_statuses.actions.change_status')
          : window.I18n.t('workflow_statuses.actions.select_status'),
    }
  },
  computed: {
    currentStatus() {
      return this.workflowStatuses.find(
        (x) => x.id === parseInt(this.currentWorkflowStatusId)
      )
    },
    statusChangeButtonClass() {
      return {
        'workflow-status__label--attached':
          this.enableStatusChange && this.currentStatus,
      }
    },
  },
  methods: {
    openWorkflowStatusChangeForm() {
      this.workflowStatusChangeFormVisible = true
    },
    closeWorkflowStatusChangeForm() {
      this.workflowStatusChangeFormVisible = false
    },
    setStatusAndHideForm(status) {
      this.workflowStatusChangeFormVisible = false
      this.currentWorkflowStatusId = status
    },
  },
}

export default WorkflowStatus
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.workflow-status {
  &__label {
    border-color: -color('snow', 'darker');

    &--attached {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
    }
  }

  &__container {
    display: inline-flex;
  }

  &__button {
    border-color: -color('snow', 'darker');
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
